import { useEffect, useState } from 'react';

export const useNetworkState = () => {
    const [networkId, setNetworkId] = useState<number | null>(null);

    useEffect(() => {
        const handleChainChanged = (chainId: string) => {
            setNetworkId(parseInt(chainId, 16));
        };

        if (window.ethereum) {
            window.ethereum.on("chainChanged", handleChainChanged);
            window.ethereum.request({ method: "eth_chainId" }).then((chainId: string) => {
                setNetworkId(parseInt(chainId, 16));
            });
        }

        return () => {
            if (window.ethereum) {
                window.ethereum.removeListener("chainChanged", handleChainChanged);
            }
        };
    }, []);

    return networkId;
};